// =============================================================================
// Landed-cost catalogue (Purchase > Stocked Pricing)
// The 6-stage build-up of a stocked item's landed unit cost. Each stage is a
// collapsible column group; the grand total (sum of every component) is what
// gets written back to act_stock_codes.cost_amount.
//
// `component.code` MUST match the backend allow-list
// (LANDED_COST_COMPONENTS in purchaseController.js) and is stored verbatim in
// bud_stock_pricing.component_code.
// =============================================================================

export const VAT_COMPONENT = 'vat';

export const LANDED_COST_STAGES = [
  {
    code: 's1',
    label: 'Base Purchase Price',
    short: 'Base Price',
    components: [
      { code: 'base_price', label: 'Supplier Price' },
      { code: 'discounts',  label: 'Discounts / Rebates' },
    ],
  },
  {
    code: 's2',
    label: 'Origin Handling & Logistics',
    short: 'Origin',
    components: [
      { code: 'origin_loading',   label: 'Loading Charges' },
      { code: 'origin_transport', label: 'Local Transport to Port' },
      { code: 'origin_customs',   label: 'Export Docs / Customs' },
    ],
  },
  {
    code: 's3',
    label: 'Main Transport & Freight',
    short: 'Freight',
    components: [
      { code: 'main_freight',      label: 'Freight (Ocean/Air/Rail)' },
      { code: 'fuel_surcharge',    label: 'Fuel Surcharge / BAF' },
      { code: 'transit_insurance', label: 'Transit Insurance' },
    ],
  },
  {
    code: 's4',
    label: 'Destination Port & Import',
    short: 'Import',
    components: [
      { code: 'import_duty',       label: 'Import Duty / Tariff' },
      { code: 'customs_clearance', label: 'Customs Clearance' },
      { code: 'port_handling',     label: 'Port Handling (THC)' },
      { code: 'vat',               label: 'VAT', isVat: true },
    ],
  },
  {
    code: 's5',
    label: 'Inland Transport',
    short: 'Inland',
    components: [
      { code: 'inland_haulage', label: 'Trucking / Haulage' },
      { code: 'tolls',          label: 'Toll Fees' },
      { code: 'demurrage',      label: 'Demurrage' },
    ],
  },
  {
    code: 's6',
    label: 'Site Receiving & Put-Away',
    short: 'Receiving',
    components: [
      { code: 'unloading_labor',  label: 'Unloading Labour' },
      { code: 'inspection_qa',    label: 'Inspection / QA' },
      { code: 'forklift_putaway', label: 'Put-Away / Forklift' },
    ],
  },
];

// Flat list of every component, in display order.
export const ALL_COMPONENTS = LANDED_COST_STAGES.flatMap((s) =>
  s.components.map((c) => ({ ...c, stage: s.code }))
);

export default LANDED_COST_STAGES;
